// Tiny helpers to render a locale code as flag + uppercase code (e.g. "🇩🇪 DE").
// Handles 2-letter locale codes (de, es, en, …) and locale variants (en-US, de-DE).
// English defaults to the UK flag for European-internal-tool context — override
// the mapping if you want US instead.

const LOCALE_TO_COUNTRY = {
  en: 'GB',
  de: 'DE',
  es: 'ES',
  fr: 'FR',
  nl: 'NL',
  it: 'IT',
  pt: 'PT',
  da: 'DK',
  sv: 'SE',
  no: 'NO',
  fi: 'FI',
  pl: 'PL',
  cs: 'CZ',
  el: 'GR',
  ja: 'JP',
  zh: 'CN',
};

function countryFor(locale) {
  if (!locale) return '';
  const parts = String(locale).split('-');
  // For 'en-US' / 'de-DE' style variants, prefer the country segment.
  if (parts.length > 1 && /^[A-Za-z]{2}$/.test(parts[parts.length - 1])) {
    return parts[parts.length - 1].toUpperCase();
  }
  const base = parts[0].toLowerCase();
  return LOCALE_TO_COUNTRY[base] || (base.length === 2 ? base.toUpperCase() : '');
}

export function flagEmoji(locale) {
  const country = countryFor(locale);
  if (!/^[A-Z]{2}$/.test(country)) return '';
  const A = 0x1f1e6;
  const offset = 'A'.charCodeAt(0);
  return String.fromCodePoint(
    A + country.charCodeAt(0) - offset,
    A + country.charCodeAt(1) - offset,
  );
}

// "🇩🇪 DE" — flag + uppercase locale code, single space. Falls back to uppercase
// code only when no flag mapping is available.
export function localeLabel(locale) {
  if (!locale) return '';
  const flag = flagEmoji(locale);
  const code = String(locale).toUpperCase();
  return flag ? `${flag} ${code}` : code;
}
